<template>
  <div>
    <div
      v-if="isModal"
      class="modal-dialog__close"
      @click="hideTrackModal"
    />
    <div
      class="modal-dialog__wrapper modal-dialog__wrapper_no-centered"
      :class="{'modal-dialog__wrapper_no-shadow': !isModal}"
    >
      <div class="track-widget">
        <div class="track-widget__header">
          <ul
            class="formbar-fields formbar-fields_track-widget"
            :class="{
              'formbar-fields_three-col': !isModal,
              'formbar-fields_two-col': isModal
            }"
          >
            <li class="formbar-field formbar-field__title">
              <div class="field-title">
                <span>Введите номер отправления:</span>
              </div>
            </li>

            <li class="formbar-field formbar-field_track-widget">
              <div
                class="field-input"
                :class="{
                  'field-full': trackNumber
                }"
              >
                <span class="label-description">Введите номер отправления</span>
                <input
                  ref="input"
                  id="box"
                  v-model="trackNumber"
                  class="field-input__inner"
                  required=""
                  placeholder="Введите номер отправления"
                  type="text"
                  @keyup.enter="getRecipientData(trackNumber)"
                >
                <svg
                  class="formbar-fields__icon_track-widget"
                  width="24"
                  height="24"
                  @click="getRecipientData(trackNumber)"
                >
                  <path d="M16.8429 11.5179C17.2334 11.9084 17.2334 12.5416 16.8429 12.9321L10.575 19.2C10.2851 19.4899 9.81495 19.4899 9.525 19.2C9.23505 18.91 9.23505 18.4399 9.525 18.15L15.45 12.225L9.525 6.29998C9.23505 6.01003 9.23505 5.53992 9.525 5.24998C9.81495 4.96003 10.285 4.96003 10.575 5.24998L16.8429 11.5179Z" fill="#50616F"/>
                </svg>
              </div>
            </li>
            <li
              v-if="!isModal"
              class="formbar-field formbar-field_search formbar-field_button"
            >
              <a
                class="formbar-field__button"
                href="#"
                @click="getRecipientData(trackNumber)"
              >
                <span>Отследить</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="track-widget__content">
          <div
            v-if="respEmpty"
            class="track-widget-list_empty empty-search-result"
          >
            <span class="empty-search-result__title">Номер заказа не найден по нескольким причинам:</span>

            <div class="empty-search-result__wrap">
              <div class="empty-search-result__col">
                <div class="empty-search-result__col__icon-wrap">
                  <span class="empty-search-result__icon icon-time" />
                  <span class="empty-search-result__col-title">Скоро станет доступен</span>
                </div>
                <span class="empty-search-result__text">
                  В&nbsp;связи с&nbsp;особенностями информационного обмена отслеживание заказов из&nbsp;некоторых интернет-магазинов может производиться с&nbsp;задержкой в&nbsp;несколько дней. Приносим вам извинения за&nbsp;временные неудобства и&nbsp;надеемся на&nbsp;понимание.
                </span>
              </div>

              <div class="empty-search-result__col">
                <div class="empty-search-result__col__icon-wrap">
                  <span class="empty-search-result__icon icon-search" />
                  <span class="empty-search-result__col-title">Попробуйте еще раз</span>
                </div>
                <span class="empty-search-result__text">
                  Возможно, номер заказа написан с ошибкой. Проверьте введенный номер или обратитесь в&nbsp;нашу техподдержку.
                </span>
              </div>
            </div>
            <CalcComment
              class="track-widget__warning"
              text-big
            >
              <div>
                Чтобы увидеть свои отправления, авторизуйтесь в <a :href="mobileAppLink" class="link-text" target="_blank" rel="noopener">мобильном приложении Boxberry</a>
                или{{'\xa0'}}в{{'\xa0'}}<a href="https://lk.boxberry.ru/auth/?redirectTo=%2F" class="link-text" target="_blank" rel="noopener">личном{{'\xa0'}}кабинете</a>
              </div>
            </CalcComment>
          </div>

          <div
            v-if="(tracksData.length && searching) || (!tracksData.length && searching) || (tracksData.length && !searching)"
            class="track-widget-list"
          >
            <div
              v-if="tracksData.length && searching"
              class="track-widget-list__header"
            >
              <span>Отправитель</span>
              <span>№ отправления в магазине</span>
              <span>№ отправления Boxberry</span>
            </div>

            <div
              v-if="!tracksData.length && searching"
              class="track-widget-list__loading"
            >
              <span class="track-widget-list__loading-title">Загрузка...</span>

              <div class="loader-overlay">
                <span class="loader-img" />
              </div>
            </div>

            <div
              v-if="tracksData.length && !searching"
              class="track-widget-list__content"
            >
              <TrackWidgetItem
                v-for="(track, index) in tracksData"
                :key="index"
                :track="track"
                :force-open="tracksData.length === 1"
              />
            </div>
          </div>
          <div
            v-if="tracksData.length || respEmpty || searching"
            class="track-widget__block-mobile-apps"
          >
            <BlockMobileApps
              :app-store-link="appStoreLink"
              :google-play-link="googlePlayLink"
              :huawei-link="huaweiLink"
              :qr-code-image-src="qrCodeImageSrc"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global ym */
import TrackWidgetItem from './TrackWidgetItem.vue';
import BlockMobileApps from './BlockMobileApps.vue';
import CalcComment from '../CalculatorPIP/components/CalcComment.vue';
import { MOBILE_STORES } from '../../helpers/constans';

const axios = require('axios');
// eslint-disable-next-line
const URL_PREFIX = urlPrefix;

export default {
  name: 'TrackingWidget',
  components: {
    CalcComment,
    BlockMobileApps, TrackWidgetItem,
  },
  props: {
    initialTrackNumber: {
      type: String,
      default: '',
    },
    isModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      trackNumber: this.initialTrackNumber,
      tracksData: [],
      respEmpty: false,
      searching: false,
      googlePlayLink: `${MOBILE_STORES.GOOGLE_PLAY}?click_id={futter}`,
      appStoreLink: `${MOBILE_STORES.APP_STORE}?click_id={futter}`,
      huaweiLink: MOBILE_STORES.APP_GALLERY,
      qrCodeImageSrc: 'https://storage.yandexcloud.net/boxberrysite-public/img/qr-code.svg',
    };
  },
  computed: {
    mobileAppLink() {
      if (/iPad|iPhone|iPod|blackberry|Mac/i.test(window.navigator.userAgent)) {
        return MOBILE_STORES.APP_STORE;
      }
      if (/huawei/i.test(window.navigator.userAgent)) {
        return MOBILE_STORES.APP_GALLERY;
      }
      return MOBILE_STORES.GOOGLE_PLAY;
    },
  },
  mounted() {
    this.$bvModal.show('trackWidget');

    if (this.trackNumber) {
      this.getRecipientData(this.trackNumber);
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', () => {});
  },

  methods: {
    hideTrackModal() {
      this.$bvModal.hide('trackWidget');
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
        // console.log('cancel request done');
      }
    },
    getRecipientData(track) {
      this.$refs.input.blur();
      if (!track) return;
      const self = this;
      const recipientUrl = URL_PREFIX
        ? `${URL_PREFIX}api/v1/tracking/order/get?searchId=${track}&limit=100`
        : `/api/v1/tracking/order/get?searchId=${track}&limit=100`;

      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      this.tracksData = [];
      this.respEmpty = false;

      this.searching = true;

      axios.get(recipientUrl, {
        cancelToken: this.cancelSource.token,
      })
        .then((resp) => {
          if (resp.data && resp.data && resp.data.parcel_with_statuses.length) {
            self.tracksData = resp.data.parcel_with_statuses;
            self.respEmpty = false;
          } else {
            self.respEmpty = true;
          }
          if (typeof ym !== 'undefined') {
            ym(57872296, 'reachGoal', 'tracking_page');
          }
        })
        .catch((err) => {
          if (err.response) {
            self.respEmpty = true;
          }
        })
        .finally(() => {
          this.searching = false;
        });
    },
  },
};
</script>

<style lang="scss">
  @import "./TrackWidget.scss";
</style>
